import {Form, RadioInput, TextInput} from 'src/design-system';
import React from 'react';

interface Props {
  error?: string;
  enableReinitialize?: boolean;
  handleSubmit?: (payload: any, formik: any) => void;
  validationSchema: any;
  prompt: any;
  cancelled: (formik: any) => void;
}

const PromptForm = ({
  error,
  enableReinitialize,
  handleSubmit,
  cancelled,
  prompt,
  validationSchema,
}: Props) => {
  const initialValues = {
    name: prompt ? prompt.name : '',
    acronym: prompt ? prompt.acronym : '',
    promptType: prompt ? prompt.promptType : '',
    enabled: prompt ? prompt.enabled : true,
  };

  return (
    <Form
      error={error}
      enableReinitialize={enableReinitialize}
      handleSubmit={handleSubmit}
      cancelled={cancelled}
      initialValues={initialValues}
      validationSchema={validationSchema}>
      <RadioInput
        valueKey={'promptType'}
        name={'Prompt Type'}
        buttons={[
          {
            value: 'Antecedents',
            title: 'Antecedents',
          },
          {
            value: 'Consequences',
            title: 'Consequences',
          },
          {
            value: 'Prompts',
            title: 'Prompts',
          },
        ]}
      />
      <TextInput valueKey={'name'} name={'Name'} />
      <TextInput valueKey={'acronym'} name={'Acronym'} />
    </Form>
  );
};

export default PromptForm;
